import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { PageTitle, PageSubTitle } from 'Components/Titles';
import RoundedPanel from 'Components/RoundedPanel';
import { Loader } from 'Components/Loader';
import { ErrorBoundary } from 'Components/ErrorBoundary/ErrorBoundary';
import { classCombine } from 'Utils/Utils';
import './CenterFrameLayout.css';
import { StatusIndicator } from 'Components/StatusIndicator';
import { getFeatureFlag } from 'Utils/FeatureFlags';

function CenterFrameLayoutComponent({
  children,
  title,
  subtitle,
  status,
  statusType,
  noPanel,
  modernLayout,
  customClass = '',
  customFrameClass = '',
  showLoader,
  appLoading,
  privacyMaskTitle,
  panelStyle,
  goBack = '',
  backUrl = '/',
}) {
  const loading = appLoading || showLoader;

  return (
    <ErrorBoundary name="center frame">
      <div className={`centerFrameLayout ${modernLayout && 'modernLayout'} ${customClass}`}>
        {(title || loading) && (
          <PageTitle modernLayout={modernLayout} text={title} alignText="center" privacyMaskTitle={privacyMaskTitle} />
        )}
        {subtitle && <PageSubTitle text={subtitle} alignText="center" />}
        {status && !loading && <StatusIndicator status={status} type={statusType} />}
        {goBack && (
          <Link to={backUrl} className="backButton">
            <img className="backIcon" src="/account/static/images/arrow-back-white.svg" alt="back-arrow" />
            <span className="backText">{goBack}</span>
          </Link>
        )}
        <RoundedPanel noPanel={noPanel} style={panelStyle}>
          <div className={classCombine('frameContentContainer', customFrameClass, loading && 'loading')}>
            {loading ? <Loader /> : children}
          </div>
        </RoundedPanel>
      </div>
    </ErrorBoundary>
  );
}

const CenterFrameLayout = connect(({ pageLayout: { appLoading } }) => ({
  appLoading,
}))(CenterFrameLayoutComponent);

export default CenterFrameLayout;
